import React from "react";

const AppML_Amazon_RDS_SQL = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Amazon RDS SQL</h1>
      <p>This is the AppML Amazon RDS SQL page content.</p>
    </div>
  );
};

export default AppML_Amazon_RDS_SQL;
